import { ShipmentLogo } from '@/modules/pmt/components/ShipmentLogo';
import { type IShipmentData, ShipmentSearchStatus } from '@/modules/pmt/interfaces';

interface IShipmentCardLogoProps {
  shipmentData?: IShipmentData;
  shipmentState: ShipmentSearchStatus;
}

const allowedLogoStates = [ShipmentSearchStatus.Fetched, ShipmentSearchStatus.Timeout];

const ShipmentCardLogo = ({ shipmentData, shipmentState }: IShipmentCardLogoProps) => {
  if (!allowedLogoStates.includes(shipmentState)) return null;

  if (shipmentData?.isSMEShipment) {
    return (
      <ShipmentLogo
        variant='sme'
        smeLogo={shipmentData.merchantInfo?.logo}
        merchantName={shipmentData.merchantInfo?.merchantName}
      />
    );
  }

  // https://www.pivotaltracker.com/n/projects/2649247/stories/187067875
  if (shipmentData?.isMockCarrierShipment && !shipmentData.isEmailSyncShipment) return null;

  const firstLineItemImage = shipmentData?.lineItems?.[0]?.productImageUrl;
  if (firstLineItemImage) {
    return <ShipmentLogo variant='merchant' merchantLogo={firstLineItemImage} />;
  }

  const orderSourceLogo = shipmentData?.additionalInfo?.orderSourceLogo;
  if (orderSourceLogo) {
    return <ShipmentLogo variant='merchant' merchantLogo={orderSourceLogo} />;
  }

  const orderSourceName = shipmentData?.orderTracking?.orderSourceName;
  if (orderSourceName) {
    return <ShipmentLogo variant='merchant' merchantLogo={orderSourceName} />;
  }

  const senderDomain = shipmentData?.additionalInfo?.senderDomain;
  if (senderDomain) {
    return <ShipmentLogo variant='merchant' merchantName={senderDomain} />;
  }

  const carrierLogo = shipmentData?.parcel?.lastEvent?.carrier?.logo;
  if (carrierLogo) {
    return <ShipmentLogo variant='carrier' carrierLogo={carrierLogo} />;
  }

  return null;
};

export { ShipmentCardLogo };
